import React from 'react';
import {Table, TablePaginationConfig} from "antd";
import {OfficersTableConfig} from "./Officers.table.config";
import {IOfficer} from "../../../api/Officer/Officer.types";

interface Props {
    data:IOfficer[]
    pagination:TablePaginationConfig
}

function OfficersTable({ data, pagination }:Props){
    return (
        <div className='officers-table'>
            <div className='officers-table-content'>
                <Table rowKey='id' dataSource={data} columns={OfficersTableConfig()} pagination={pagination}/>
            </div>
        </div>
    )
}

export default OfficersTable;